<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
        <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
            <!--begin::navbar-->
            <navbar-component></navbar-component>
            <!--end::navbar-->
  
            <div class="page-wrapper">
  
                    <!--begin::content-->
                    <div class="page-content">
                        <div class="row">
                            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                                <div class="card">

                                    <!--header-->
                                    <div class="card-header">
                                        <div class="row mb-3">
                                            <h4 style="margin-right: 5px" class="float-start">{{$t("cmlDetailDataAkumActivity") }}</h4>
                                        </div>
                                        <div class="card-body mt-0">
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('idBillingHeader')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="idBillingHeader"
                                                    :placeholder="$t('idBillingHeader')" v-model="formsHeader.idBillingHeader"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('transactionDate_txt')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="transactionDate"
                                                    :placeholder="$t('transactionDate_txt')" v-model="formsHeader.transactionDate"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('customerId')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="customerId"
                                                    :placeholder="$t('customerId')" v-model="formsHeader.customerId"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('warehouseId_txt')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="warehouseId"
                                                    :placeholder="$t('warehouseId_txt')" v-model="formsHeader.warehouseId"
                                                    disabled />
                                                </div>
                                            </div>  
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('statusTxt')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="status"
                                                    :placeholder="$t('statusTxt')" v-model="formsHeader.status"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{ $t('amount_txt') }}
                                                    </label>
                                                    <input type="text" class="form-control" id="amount"
                                                    :placeholder="$t('amount_txt')" v-model="formsHeader.amount"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">Group Category</label>
                                                    <v-select
                                                    :options="searchBy"
                                                    label="groupCategory"
                                                    :reduce="filter=>filter.groupCategory"
                                                    v-model="groupCategory"
                                                    >
                                                    </v-select>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="mb-5">
                                                        <button @click="searchFunction" style="margin-right: 10px;" class="btn btn-primary mt-4 " type="button" >Search</button>
                                                    </div>
                                                </div>


                                            </div>   
                                                
                                        </div>
                                        <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                                            style="margin-right: 5px" @click.prevent="downloadData()">
                                            <span class="mdi mdi-download h4"></span>
                                            {{ $t("downloadData") }} .xlsx
                                        </button>
                                        <button class="btn btn-primary text-light fw-bolder btn-icon-text"
                                            @click="backForm" type="button">
                                            <i class="link-icon mdi mdi-arrow-left"></i>
                                            {{ $t("backMess") }}
                                        </button>
                                    </div>
                                    <!--header-->

                                    <!--table-->
                                    <div class="card-body">
                                        <vue-good-table 
                                        title="list-bill-cml-bill-detail-data-akum-activity"
                                        ref="list-bill-cml-bill-detail-data-akum-activity"
                                        :select-options="{enabled: false, selectOnCheckboxOnly: false,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}" 
                                        mode="remote" styleClass="vgt-table striped"
                                        @on-selected-rows-change="selectionChanged" 
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange" 
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange" 
                                        :totalRows="totalRecords" 
                                        :line-numbers="true"
                                        :isLoading.sync="isLoading" 
                                        :pagination-options="{
                                            enabled: true,
                                            perPageDropdown: [10, 50, 100, 1000, 10000],
                                            dropdownAllowAll: false,
                                        }" 
                                        :rows="rows" 
                                        :columns="columns">

                                            <!--<div slot="table-actions">
                                                {{ $t("no_select_data") }}
                                            </div>-->
                                            <div slot="selected-row-actions">
                                                <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="selectionChangeStatus"> <i
                                                    class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>
                                                <button class="btn btn-success btn-xs" @click="removeSelections"><i class="mdi mdi-close"></i> {{
                                                    $t("unselect_data_txt")
                                                }} </button>
                                            </div>

                                            <template slot="column-filter" slot-scope="{ column }">
                                                <span v-if="column.filterOptions.customFilter">
                                                    <span v-if="column.field == 'trxDate'">
                                                        <date-range-picker style="width:100%" @update="trxDateChange"
                                                            control-container-class="form-control"
                                                            :locale-data="{ format: 'yyyy-mm-dd' }" v-model="trxDate"
                                                            :opens="opens" :singleDatePicker="false" :timePicker24Hour="false"
                                                            :timePicker="false" :showWeekNumbers="false">
                                                            <div slot="header" slot-scope="header" class="slot">
                                                                <a @click="cleartrxDateChange()" class="float-end"
                                                                    style="margin-right: 5px;color:red;">Clear Calendar</a>
                                                                <span v-if="header.in_selection"> - in selection</span>
                                                                <br>
                                                            </div>
                                                        </date-range-picker>
                                                    </span>
                                                </span>
                                            </template>

                                            <template slot="table-row" slot-scope="props">
                                                <span v-if="props.column.field == 'actions'">
                                                    <a href="#" v-if="permision_role.method_update && props.row.status === 'MATCH' || permision_role.method_update && props.row.status === 'UNMATCH'" title="CANCEL" @click.prevent=" changeStatusData(props.index, props.row , 'CANCEL')">
                                                        <button class="btn btn-danger btn-xs">CANCEL</button>
                                                    </a>
                                                    <a href="#" v-else @click.prevent="changeStatusData(props.index, props.row, 'UNMATCH')">
                                                        <button class="btn btn-primary btn-xs">UNMATCH</button>
                                                    </a>
                                                </span>
                                                <span v-else-if="props.column.field == 'status'">
                                                    <span v-if="props.row.status == 'MATCH'" class="badge bg-info"><h5>{{props.row.status}}</h5></span>
                                                    <span v-else-if="props.row.status == 'UNMATCH'" class="badge bg-primary"><h5>{{props.row.status}}</h5></span>
                                                    <span v-else class="badge bg-danger"><h5>{{props.row.status}}</h5></span>
                                                </span>
                                                <span v-else>
                                                    {{ props.formattedRow[props.column.field] }}
                                                </span>
                                            </template>

                                        </vue-good-table>
                                    </div>
                                    <!--table-->

                                </div>
                            </div>
                        </div>
                    </div>
                    <!--end::content-->
  
                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->


            </div>

      </div>
    </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from 'vue2-daterange-picker';

export default {
    name    : "CmlBillDetDataAkumActivity",
    props   : {},
    components  : {
        "navbar-component"  : navbarComponent,
        "footer-component"  : footerComponent,
        DateRangePicker
    },
    data() {
        return {
            opens   : "center",
            locale  : {
                format  : "yyyy-mm-dd",
            },
            trxDate : {
                startDate   : null,
                endDate     : null
            },
            firstDates  : {
                startDate   : null,
                endDate     : null
            },
            highlighted :{
                dates   : [ // Highlight an array of dates
                    new Date(),
                ],
            },
            serverParams    : {
                columnFilters   : {},
                sort    : {
                    field   : "",
                    type    : "",
                },
                page        : 1,
                per_page    : 10,
            },
            maxToasts           : 100,
            position            : "up right",
            closeBtn            : true,
            isLoading           : false,
            errors              : [],
            permision_role      : [],
            langs               : ["id", "en"],
            detailUser          : [],
            detailDivisi        : [],
            totalRecords        : 0,
            
            search      : [],
            searchBy    : [
                {
                    groupCategory : "All",
                },
            ],
            
            groupCategorys          : [],
            groupCategory           : "All",
            trxDateFrom             : "",
            trxDateTo               : "",
            idBillingHeader         : [],
            rows                    : [],
            rowsSelection           : [],
            idCodeLkupsSelections   : [],

            forms               : {idBillingDetail: "",  idBillingHeader:"",  chargeCategory:"", chargeType:"", SAPMaterialCode:"", SAPDivision:"",  amountCategory:"" , addwho:"", editwho:"",  qtyCharge:"", rate:""},
            formsHeader         : {idBillingHeader: "",  tariffId:"",  customerId:"", warehouseId:"", transactionToDate:"", transactionFromDate:"",  status:"" , amount:"", idRateHeader:"",  transactionDate:"", addwho:"",  editwho:"", adddate:"",  editdate:""},
            formsDataSumSAP     : { BtDetailDataCustSapCancelCount: "0", DataCustSapTotalRowsCount: "0", DataCustSapMatchCount: "0", DataCustSapUnmatchCount: "0" },
            columns             : [
                {
                label: this.$t("idBillingDetail"),
                field: "idBillingDetail",
                thClass: "text-center",
                width: '80px',
                filterOptions: {
                    customFilter: false,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("idBillingDetail"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("idSubBillingDetail"),
                field: "idSubBillingDetail",
                thClass: "text-center",
                width: '80px',
                filterOptions: {
                    customFilter: false,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("idSubBillingDetail"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("rateBaseDesc"),
                field: "rateBaseDesc",
                thClass: "text-center",
                width: '200px',
                filterOptions: {
                    customFilter: false,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("rateBaseDesc"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("trxDate"),
                field: "trxDate",
                thClass: "text-center",
                width: "120px",
                filterOptions: {
                    customFilter: true,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("trxDate"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("QTY_CS"),
                field: "QTY_CS",
                thClass: "text-center",
                width: "80px",
                filterOptions: {
                    customFilter: true,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("QTY_CS"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("sumQtyAkumActvity"),
                field: "sumQtyAkumActvity",
                thClass: "text-center",
                width: "80px",
                filterOptions: {
                    customFilter: true,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("sumQtyAkumActvity"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("qtyEach"),
                field: "qtyEach",
                thClass: "text-center",
                width: "80px",
                filterOptions: {
                    customFilter: true,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("qtyEach"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("grossWeight"),
                field: "grossWeight",
                thClass: "text-center",
                width: "80px",
                filterOptions: {
                    customFilter: true,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("grossWeight"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("qtyPallet"),
                field: "qtyPallet",
                thClass: "text-center",
                width: "80px",
                filterOptions: {
                    customFilter: true,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("qtyPallet"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("qtyExcess"),
                field: "qtyExcess",
                thClass: "text-center",
                width: '100px',
                filterOptions: {
                    customFilter: true,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("qtyExcess"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("excessFlag"),
                field: "excessFlag",
                thClass: "text-center",
                width: '100px',
                filterOptions: {
                    customFilter: false,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("all"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: ["Y", "N"], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("qtyChargeExcess"),
                field: "qtyChargeExcess",
                thClass: "text-center",
                width: '100px',
                filterOptions: {
                    customFilter: true,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("qtyChargeExcess"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("HI_QTY_CS"),
                field: "HI_QTY_CS",
                thClass: "text-center",
                width: '100px',
                filterOptions: {
                    customFilter: true,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("HI_QTY_CS"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("HO_QTY_CS"),
                field: "HO_QTY_CS",
                thClass: "text-center",
                width: "100px",
                filterOptions: {
                    customFilter: true,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("HO_QTY_CS"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("groupCategory"),
                field: "groupCategory",
                thClass: "text-center",
                width: "200px",
                filterOptions: {
                    customFilter: true,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("groupCategory"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("seqNumAkum"),
                field: "seqNumAkum",
                thClass: "text-center",
                width: "100px",
                filterOptions: {
                    customFilter: true,
                    enabled: true, // enable filter for this column
                    placeholder: this.$t("seqNumAkum"), // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                    },
                }
            ],

        };
    },
    watch   : {},
    methods : {
    
        dropdownGroupCategory()
        {

            var params      = this.$onBehind(this.$route.params.id);
            const baseURI   = this.$settings.endPointBilling + "dashboard/cml-billing/billing/group-category-akum-activity/" + params[0];    
            return this.$http
            .get(
                baseURI
            )
            .then((response) => {
                this.groupCategorys = response.data;
                Object.values(this.groupCategorys).forEach((value) => {
                    this.searchBy.push(value);
                });
            });

        },

        searchFunction()
        {
            var groupCategory   = "groupCategory";
            var data            = {};
            //console.log(this.groupCategory);
            if(this.groupCategory !== "All" && this.groupCategory !== null)
            {
                data[groupCategory] = this.groupCategory;
            }

            let trxDateFrom = this.trxDateFrom
            let trxDateTo   = this.trxDateTo
            var params      = this.$onBehind(this.$route.params.id);
            const baseURI   = this.$settings.endPointBilling + "dashboard/cml-billing/billing/index-sum-akum-activity/" + params[0];
            this.isLoading  = true;
            return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&trxDateFrom=${trxDateFrom}&trxDateTo=${trxDateTo}&idBillingDetail=${this.serverParams.columnFilters.idBillingDetail}&rateBaseDesc=${this.serverParams.columnFilters.rateBaseDesc}&excessFlag=${this.serverParams.columnFilters.excessFlag}&idSubBillingDetail=${this.serverParams.columnFilters.idSubBillingDetail}`
                    ,{params: data},{ timeout: 60000 })
                .then((response) => {
                    this.rows = response.data.datas.data;
                    this.totalRecords = response.data.datas.total;
                    this.isLoading = true;
                }).catch((error) => {
                    this.loading();
                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
                    } else {
                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            } else {
                                this.$router.push('/page-not-found');
                            }
                        }
                    }
                });
            
        },

        toCurrency (value) 
        {
            if (typeof value !== "number") {
                return value;
            }
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'IDR'
            });
            return formatter.format(value);
        },

        fade(sType) 
        {
            this.isLoading = sType;
        },

        loading() 
        {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data)
        {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                this.error(objectData[y]);
                }
            }
        },

        success(kata) 
        {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
                // onShown: function() {
                //     console.log('asdasdasd');
                //     //window.location.href = '/';
                // }
            });

            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata)
        {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        logout()
        {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
                
            console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        backForm() 
        {
            var params = this.$onRandom(this.formsHeader.idBillingHeader);
            window.location.href = "/billing-cml/billing/header/detail/" + params;
        },

        loadItems() 
        {

            var groupCategory   = "groupCategory";
            var data            = {};
            //console.log(this.groupCategory);
            if(this.groupCategory !== "All" && this.groupCategory !== null)
            {
                data[groupCategory] = this.groupCategory;
            }
            let trxDateFrom = this.trxDateFrom
            let trxDateTo   = this.trxDateTo
            var params = this.$onBehind(this.$route.params.id);
            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/index-sum-akum-activity/" + params[0];
            this.isLoading = true;
            return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&trxDateFrom=${trxDateFrom}&trxDateTo=${trxDateTo}&idBillingDetail=${this.serverParams.columnFilters.idBillingDetail}&rateBaseDesc=${this.serverParams.columnFilters.rateBaseDesc}&excessFlag=${this.serverParams.columnFilters.excessFlag}&idSubBillingDetail=${this.serverParams.columnFilters.idSubBillingDetail}`,
                    {params: data}, { timeout: 60000 })
                .then((response) => {
                    this.isLoading = false;
                    this.rows = response.data.datas.data;
                    this.totalRecords = response.data.datas.total;
                }).catch((error) => {
                        this.loading();

                        if (error.code == "ECONNABORTED") {
                            this.error(this.$t("check_internet_connection_txt"));

                        } else {

                            if (error.response) {
                                if (error.response.status === 422) {
                                    this.errors = error.response.data.errors;
                                    this.resultError(error.response.data.errors);
                                } else if (error.response.status === 401) {
                                    this.logout();
                                } else if (error.response.status === 403) {
                                    this.$router.push("/authorized-error");
                                } else if (error.response.status === 500) {
                                    this.$router.push('/server-error');
                                } else {
                                    this.$router.push('/page-not-found');
                                }
                            }

                        }

                });
        },

        downloadData() 
        {
            
            var params      = this.$onBehind(this.$route.params.id);
            const baseURI   = this.$settings.endPointBilling + "dashboard/cml-billing/billing/index-sum-akum-activity/" + params[0];
            this.isLoading = true;
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name   = "download_" + CurrentDate + ".xlsx";
    
            let trxDateFrom = this.trxDateFrom
            let trxDateTo   = this.trxDateTo

            var filter      = null;
            //console.log(this.groupCategory);
            if(this.groupCategory == "All" || this.groupCategory == null)
            {
                filter = `?download=download&limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&trxDateFrom=${trxDateFrom}&trxDateTo=${trxDateTo}&idBillingDetail=${this.serverParams.columnFilters.idBillingDetail}&rateBaseDesc=${this.serverParams.columnFilters.rateBaseDesc}&excessFlag=${this.serverParams.columnFilters.excessFlag}&idSubBillingDetail=${this.serverParams.columnFilters.idSubBillingDetail}`;
            }
            else
            {
                filter = `?groupCategory=${this.groupCategory}&download=download&limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&trxDateFrom=${trxDateFrom}&trxDateTo=${trxDateTo}&idBillingDetail=${this.serverParams.columnFilters.idBillingDetail}&rateBaseDesc=${this.serverParams.columnFilters.rateBaseDesc}&excessFlag=${this.serverParams.columnFilters.excessFlag}&idSubBillingDetail=${this.serverParams.columnFilters.idSubBillingDetail}`;
            }

            return this.$http
            .get(
                baseURI + filter
                ,{ responseType: "blob"},
            )
            .then((response) => {
                this.isLoading = false;
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.fade(false);
            });
        },

        updateParams(newProps) 
        {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
                this.loadItems();
        },

        onColumnFilter(params) 
        {
                this.updateParams(params);
        },

        onPageChange(params) 
        {
                this.updateParams({ page: params.currentPage });
        },

        onSortChange(params) 
        {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
        },

        onPerPageChange(params) 
        {
                this.updateParams({ per_page: params.currentPerPage });
        },

        selectionChanged(ev) 
        {

            this.rowsSelection = [];
            this.idCodeLkupsSelections  = [];
            this.rowsSelection = ev.selectedRows;

            this.rowsSelection.forEach((item) => {
            this.idCodeLkupsSelections.push(item.idSumAkum);

            });

        },

        trxDateChange() 
        {
            if (this.trxDate.startDate && this.trxDate.endDate) {
                this.trxDateFrom = this.$moment(String(this.trxDate.startDate)).format('YYYY-MM-DD');
                this.trxDateTo = this.$moment(String(this.trxDate.endDate)).format('YYYY-MM-DD');
                this.loadItems()
            }

        },

        cleartrxDateChange() 
        {
            this.trxDate = {
                startDate: null,
                endDate: null
            };
            this.trxDateFrom = ""
            this.trxDateTo = ""
            this.loadItems()
        },

        fetchIt() 
        {
            const userDatas       = this.$getUserInfo();
            this.userData         = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision     = [];
            userDatas.sub.permision_role.forEach(function(permision){
                if(permision.permission.controller == 'BillingCmlController'){

                rolePermision = permision;
                // console.log(permision);
                }
            });

            if(!rolePermision.method_read){
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;
            this.loadData();

        },

        loadData() 
        {
            this.isLoading = true;
            var params = this.$onBehind(this.$route.params.id);

            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/detail/" + params[0];
            return this.$http.get(baseURI,{ timeout: 60000 }).then((response) => {
                this.isLoading = false;
                this.formsHeader                      = response.data.datas;
                this.formsHeader.amount               = this.toCurrency(response.data.datas.amount);
                this.bm_rate_header                   = response.data.datas.bm_rate_header;
                this.formsHeader.transactionDate      = response.data.datas.transactionFromDate+"~"+response.data.datas.transactionToDate
            }).catch(error => {
                this.isLoading = false;
                
            
            if(error.code == "ECONNABORTED"){
                this.error(this.$t("check_internet_connection_txt"));
                
            }else{

                if (error.response) {
                    if(error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                    }else if (error.response.status === 401) {
                        this.logout();
                    } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                    }else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                    }else{
                        this.$router.push('/page-not-found');
                    }
                }

            }

            });
        },

        selectionChangeStatus()
        {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourDataSend"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "UNMATCH",
                cancelButtonText: 'CANCEL',
                }).then((result) => {
                    if (result.value) 
                    {
                            this.isLoading = true;

                            let formData = {
                                idBillingHeader: this.formsHeader.idBillingHeader,
                                idDetailCusts: this.idCodeLkupsSelections,
                                status: "UNMATCH",
                            };
                            
                            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-data-cust-sap-update-status";
                                this.$http
                                .post(baseURI, formData,{ timeout: 60000 })
                                .then((response) => {
                                this.loading();
                                    if (response.data.status === 200) 
                                    {
                                        this.success(response.data.datas.messages);
                                        this.idCodeLkupsSelections = [];
                                        this.loadItems();
                                        this.getDataSummaryBtDetailDataCustSap();
                                    } 
                                    else 
                                    {
                                        this.errors = response.data.errors;
                                        this.resultError(response.data.errors);
                                    }
                                }).catch((error) => {
                                        this.loading();

                                    if(error.code == "ECONNABORTED"){
                                        this.error(this.$t("check_internet_connection_txt"));
                                    }else{
                                    if (error.response){
                                        if(error.response.status === 422) {
                                            this.errors = error.response.data.errors;
                                            this.resultError(error.response.data.errors);
                                        }else if (error.response.status === 401) {
                                            this.logout();
                                        } else if (error.response.status === 403) {
                                            this.$router.push("/authorized-error");
                                        }else if (error.response.status === 500) {
                                            this.$router.push('/server-error');
                                        }else{
                                            this.$router.push('/page-not-found');
                                        }
                                    }

                                    }

                            });

                    }
                    else
                    {
                                
                            this.isLoading = true;
                            let formData = {
                                idBillingHeader: this.formsHeader.idBillingHeader,
                                idDetailCusts: this.idCodeLkupsSelections,
                                status: "CANCEL",
                            };

                            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-data-cust-sap-update-status";
                                this.$http
                                .post(baseURI, formData,{ timeout: 60000 })
                                .then((response) => {
                                this.loading();
                                if (response.data.status === 200) {
                                    this.success(response.data.datas.messages);
                                    this.idCodeLkupsSelections = [];
                                    this.loadItems();
                                    this.getDataSummaryBtDetailDataCustSap();

                                } else {
                                    this.errors = response.data.errors;
                                    this.resultError(response.data.errors);
                                }
                                }).catch((error) => {
                                    this.loading();
                                
                                    if(error.code == "ECONNABORTED"){
                                    this.error(this.$t("check_internet_connection_txt"));
                                    }else{

                                        if (error.response) {
                                            if(error.response.status === 422) {
                                                this.errors = error.response.data.errors;
                                                this.resultError(error.response.data.errors);
                                            }else if (error.response.status === 401) {
                                                this.logout();
                                            } else if (error.response.status === 403) {
                                                this.$router.push("/authorized-error");
                                            }else if (error.response.status === 500) {
                                                this.$router.push('/server-error');
                                            }else{
                                                this.$router.push('/page-not-found');
                                            }
                                        }

                                    }

                                });


                    }
            });

        },

        removeSelections()
        {
            this.idCodeLkupsSelections = [];
            this.$refs['list-bill-cml-bill-detail-data-akum-activity'].unselectAllInternal()
        },

        changeStatusData(index, row , statusNya) 
        {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourData"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                        var formData = {
                            idBillingHeader: this.formsHeader.idBillingHeader,
                            idDetailCusts: [row.idDetailCust],
                            status: statusNya,
                        };
                        const baseURI =
                            this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-data-cust-sap-update-status";
                            this.$http
                            .post(baseURI, formData,{ timeout: 60000 })
                            .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.loadItems();
                                this.getDataSummaryBtDetailDataCustSap();

                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                            }).catch((error) => {
                                this.loading();
                            
                                if(error.code == "ECONNABORTED"){
                                    this.error(this.$t("check_internet_connection_txt"));
                                }else{
                                    if (error.response) {
                                        if(error.response.status === 422) {
                                            this.errors = error.response.data.errors;
                                            this.resultError(error.response.data.errors);
                                        }else if (error.response.status === 401) {
                                            this.logout();
                                        } else if (error.response.status === 403) {
                                            this.$router.push("/authorized-error");
                                        }else if (error.response.status === 500) {
                                            this.$router.push('/server-error');
                                        }else{
                                            this.$router.push('/page-not-found');
                                        }
                                    }

                                }
                            });

                }else{
                this.isLoading = false;
                }
            });

        },


    },
    events  : {},
    created : function () {},
    mounted() {
        this.dropdownGroupCategory();
        this.fetchIt();
        this.loading();
    },

};

</script>

<style scoped>

.blur-content{
    filter: blur(5px); 
  }

</style>